<template>
  <el-dialog
    :visible.sync="visiable"
    width="580px"
    custom-class="normal-dialog full-dialog info-dialog hide-header-dialog"
    :close-on-click-modal="false"
    :before-close="() => (visiable = false)"
  >
    <div class="upgrade-modal">
      <div class="header-content">
        <i class="iconfont iconcha close-btn" @click="visiable = false"></i>
        <img class="header-banner" :src="headerBanner" />
        <img class="header-banner2" :src="headerBanner2" />
        <div class="header-title">
          <span>小包公</span>
          <span :style="{ margin: '0 8px' }">·</span>
          <span>法律实证分析平台</span>
        </div>
        <div class="header-version">
          <span>V{{ version }}版本</span>
        </div>
      </div>
      <div class="upgrade-content">
        <img class="bg-img" :src="bottomImg" />
        <div class="title">更新内容</div>
        <ul class="upgrade-ul">
          <li class="upgrade-li" v-for="(text, index) in upgradeArr" :key="index">
            <span>{{ text }}</span>
          </li>
        </ul>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import headerBanner from '@/assets/img/upgradeModal/headerBanner.png';
import headerBanner2 from '@/assets/img/upgradeModal/headerBanner2.png';
import bottomImg from '@/assets/img/upgradeModal/bottomImg.png';

import { computed } from 'vue';
const emit = defineEmits(['update:show']);

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
});

const visiable = computed({
  get() {
    return props.show;
  },
  set(val) {
    emit('update:show', val);
  }
});

const upgradeArr = computed(() => {
  return [
    '以检察文书为研究的课题，支持多人多事的统计研究。',
    '课题数据筛选引用法条时支持添加多个法条，法条之间支持且和或的逻辑检索。',
    '对裁判文书的段落“案件基本情况”段落进行了细分，细分为公诉机关指控、原告诉称、被告诉称和本院查明。',
    '修复了若干问题。'
  ];
});

const version = computed(() => {
  return process.env.VUE_APP_VERSION;
});
</script>

<style lang="scss" scoped>
.upgrade-modal {
  background-color: #fff;

  .header-content {
    position: relative;
    height: 140px;
    font-size: 24px;
    color: #ffffff;
    background-color: #2f69f6;

    .close-btn {
      position: absolute;
      right: 10px;
      top: 10px;
      color: #fff;
      font-weight: 500;
      font-size: 14px;
      z-index: 4;
      padding: 5px;
      cursor: pointer;
    }

    .header-banner {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
    }

    .header-banner2 {
      position: absolute;
      right: 22px;
      top: 19px;
      width: 186px;
      height: 159px;
      z-index: 2;
    }

    .header-title {
      position: absolute;
      top: 33px;
      left: 40px;
      line-height: 33px;
      z-index: 3;
    }

    .header-version {
      position: absolute;
      top: 72px;
      left: 40px;
      line-height: 29px;
      z-index: 3;
    }
  }
  .upgrade-content {
    position: relative;
    min-height: 200px;
    background-color: #fff;
    padding: 0 40px 35px;

    .bg-img {
      position: absolute;
      right: -63px;
      bottom: -53px;
      width: 262px;
      height: 262px;
      z-index: 1;
    }

    .title {
      font-size: 16px;
      color: #2c3443;
      line-height: 22px;
      font-weight: 500;
      margin: 20px 0 15px;
    }

    .upgrade-ul {
      position: relative;
      color: rgba(#2c3443, 0.8);
      font-size: 14px;
      line-height: 20px;
      padding-left: 18px;
      z-index: 2;

      .upgrade-li {
        margin-top: 12px;

        &:first-child {
          margin-top: 0;
        }
        &::marker {
          color: #1991fb;
        }
      }
    }
  }
}
</style>
